export default __webpack_public_path__ + "static/media/pos-dashboard-2.7f2a662d.webp";